import { Country } from '@weave/schema-gen-ts/dist/schemas/tendlc/shared/v1/shared.pb';

export const isBulkTextingSupportedInCountry = (country?: Country) => {
  // Bulk Texting is supported in the US and Canada. undefined is treated as US.
  if (country === undefined) {
    return true;
  }
  return country === Country.COUNTRY_US || country === Country.COUNTRY_CA;
};
